import React from "react";
import { useMemo } from "react";
import DOMPurify from "dompurify";

const SAFE_HTML_OPTIONS = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "button", "textarea", "select"],
  FORBID_ATTR: ["onerror", "onclick", "onload", "onmouseover", "onfocus", "onmouseenter"],
};

export default function SafeHtml({
  as: Component = "div",
  html,
  disableLinks = false,
  onClickCapture,
  ...props
}) {
  const sanitizedHtml = useMemo(() => {
    return DOMPurify.sanitize(String(html || ""), SAFE_HTML_OPTIONS);
  }, [html]);

  const handleClickCapture = (event) => {
    if (typeof onClickCapture === "function") {
      onClickCapture(event);
    }
    if (!disableLinks || event.defaultPrevented) return;
    if (event.target?.closest?.("a")) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Component
      {...props}
      onClickCapture={handleClickCapture}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
}
